<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-default py-7 py-lg-8 pt-lg-1">
      <b-container>
        <div class="header-body text-center mb-6">
          <b-row class="justify-content-center">
            <b-col xl="12" lg="12" md="6" class="px-5">
              <img src="../../assets/images/rynenation-logo-light-large.png" >
              <h1 class="text-white">UnityERP</h1>
              <!-- <p class="text-lead text-white">Simply Better.</p> -->
            </b-col>
          </b-row>
        </div>
      </b-container>
      <!-- <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
             xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div> -->
    </div>
    <!-- Page content -->
    <b-container class="mt--9 pb-5">
       <div>
            <vue-element-loading :active="loading" :is-full-screen="true" color="#fb6340"/>
      </div>
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <b-card no-body class="bg-secondary border-0 mb-0">
            <!-- <b-card-header class="bg-transparent pb-5"  >
              <div class="text-muted text-center mt-2 mb-3"><small>Sign in with</small></div>
              <div class="btn-wrapper text-center">
                <a href="#" class="btn btn-neutral btn-icon">
                  <span class="btn-inner--icon"><img src="img/icons/common/github.svg"></span>
                  <span class="btn-inner--text">Github</span>
                </a>
                <a href="#" class="btn btn-neutral btn-icon">
                  <span class="btn-inner--icon"><img src="img/icons/common/google.svg"></span>
                  <span class="btn-inner--text">Google</span>
                </a>
              </div>
            </b-card-header> -->
            <b-card-body class="px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <small>{{language_terms['LOGIN_FORM_TEXT']}}</small>
              </div>
              <validation-observer v-slot="{handleSubmit}" ref="formValidator">
                <b-form v-on:keyup.enter="handleLogin">
                  <base-input>
                      <el-select v-model="language_code" filterable @change="setSelectedLang">
                        <el-option v-for="option in languages"
                                  :key="option.code"
                                  :label="option.name"
                                  :value="option.code">
                        </el-option>
                      </el-select>
                    </base-input>
                    <base-input alternative
                                class="mb-3"
                                name="Email"
                                :placeholder="language_terms['USER_ID']"
                                v-model="model.handle">
                    </base-input>

                  <base-input alternative
                              class="mb-3"
                              name="Password"
                              type="password"
                              :placeholder="language_terms['PASSWORD']"
                              v-model="model.password">
                  </base-input>

                  <b-form-checkbox v-model="model.rememberMe">{{language_terms['REMEMBER_ME']}}</b-form-checkbox>
                  <div class="text-center">
                    <base-button type="primary" @click="handleLogin" class="my-4">{{language_terms['LOGIN']}}</base-button>
                  </div>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
          <b-row class="mt-3" v-if="0">
            <b-col cols="6">
              <router-link to="/dashboard" class="text-light"><small>Forgot password?</small></router-link>
            </b-col>
            <!-- <b-col cols="6" class="text-right">
              <router-link to="/register" class="text-light"><small>Create new account</small></router-link>
            </b-col> -->
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
  import VueElementLoading from 'vue-element-loading'   
  import { mapState } from "vuex";
  import {apiRoutes} from '../../apiRoutes'
  import axios from 'axios';
  import Vue from 'vue';
  import { Select, Option } from 'element-ui'


  export default {
    components:{
      VueElementLoading,
      [Select.name]: Select,
      [Option.name]: Option,
    },
    computed:{
      ...mapState({
        language_terms: state => state.languages.language_terms,
        selected_lang: state => state.languages.selected_langauge,
      }),
    },
    data() {
      return {

        loading:false,
        language_code:'en',
        languages:[
            {
              code:"en",
              name:"English"
            },
            {
              code:"zh-hant",
              name:"中文(繁体)"
            }
        ],
        model: {
          handle: '',
          password: '',
          rememberMe: false,
 
        }
      };
    },
    async mounted()
    {
      let data = localStorage.getItem("selected_langauge")

      if(data)
      {
        this.language_code = data
        this.setSelectedLang()
      }      
    },
    methods: {
      fetchAllLanguages(){
        this.loading=true
        this.$store.dispatch("languages/list", {});
        this.loading=false
      },
      setSelectedLang(){
        this.loading=true
        this.$store.dispatch("languages/setSelectedLang", this.language_code);
        this.loading=false
      },
      async handleLogin() {

        // this will be called only after form is valid. You can do api call here to login
        this.loading=true
        await axios.post(`${apiRoutes['LOGIN']}`, {handle:this.model.handle, password:this.model.password, language_code: this.language_code})
            .then(response => {
                if(response.data.code == 1)
                {
                    // Save the token.
                    this.$store.dispatch("auth/saveAuth", {
                      access_token: response.data.data.access_token,
                      user: response.data.data
                    });

                    this.$router.push("/dashboard")
                }
                else{
                  Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: "Invalid Login!",
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                }
            })
            .catch(error => {
                if (error.response) {
                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: "Login Failed!",
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                } else {
                    console.log("Problem with access", error);
                }
            });
            this.loading=false
      }
    }
  };
</script>
